import axios from 'axios'

const generateEightColumnsBalanceExcel = async function(init_date, end_date, branch_office='') {
    try {
        const path = `/acc_eight_columns_balance/excel?init_date=${init_date}&end_date=${end_date}&g_branch_office_id=${branch_office}`,
            route = process.env.VUE_APP_API_ROUTE.concat(path)
        let response = await axios({
            url: route,
            method: 'GET',
            responseType: 'blob',
        })
        return response
    } catch (error) {
        return error.response
    }
}

export { generateEightColumnsBalanceExcel }
